import { toast as message } from 'react-hot-toast';

export const toast = (info: any, opts = {}) => {
  message(info, {
    ...opts,
    style: {
      background: 'var(--black-3)',
      color: 'var(--text-color)'
    },
    duration: 3000
  });
};
